import React, { useState, useCallback, useMemo, useContext, useEffect } from 'react'
import { getJSON } from '~/utils'

const Context = React.createContext()

export function useLiterals() {
  return useContext(Context)
}

export default function LiteralsProvider({ children, language, ...props }) {
  const [literals, setLiterals] = useState()
  const [loaded, setLoaded] = useState()

  useEffect(() => {
    async function init(language = 'pt-BR') {
      const literals = await getJSON(`https://gofind-languages.s3-sa-east-1.amazonaws.com/${language}.json`)
      setLiterals(literals)
      setLoaded(true)
    }

    init(language)
  }, [language])

  /**
   * Get literal from widget language literals
   * @param {string} token literal code. Ex.: '1001'
   * @param {array} params params to replace strings like %s1, %s2, etc on selected token. The first item of array will replace %s1 and respectively
   * @example getLiteral('1046', ['joca'])
   */
  const getLiteral = useCallback(
    (token, params = []) => {
      let literal = literals ? literals[token] : ''

      params.forEach((param, index) => {
        literal = literal.replace(`%s${index + 1}`, param)
      })

      return literal && literal.length ? literal : `@${token}`
    },
    [literals],
  )

  const value = useMemo(
    () => ({
      language,
      getLiteral,
    }),
    [language, getLiteral],
  )

  return loaded ? (
    <Context.Provider value={value}>{React.cloneElement(children, props)}</Context.Provider>
  ) : null
}
